import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import configureStore from './state-management/store/configureStore';
import './scss/styles.scss';


const store = configureStore();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>

      <App />
    </Provider>

  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


/* eslint-env browser */

// import '@babel/polyfill';
// import React from 'react';
// import { render } from 'react-dom';
// import { Provider } from 'react-redux';
// import history from './history';
// import configureStore from './state-management/store/configureStore';
// import App from './containers/App/App';
// import CacheBuster from '../../CacheBuster';

// // Global styles
// import './scss/styles.scss';

// const MOUNT_NODE = document.getElementById('root');

// // const store = configureStore();

// render(
//     <CacheBuster>
//         {({ loading, isLatestVersion, refreshCacheAndReload }) => {
//             if (loading) return null;
//             if (!loading && !isLatestVersion) {
//                 refreshCacheAndReload();
//             }
//             return (
//                 <React.Fragment>
//                     <Provider store={store}>
//                         <App history={history} />
//                     </Provider>
//                 </React.Fragment>
//             );
//         }}
//     </CacheBuster>,
//     MOUNT_NODE,
// );
